import { Box, Container } from "@mui/material";
import React from "react";

import { AccountMembers } from "components/account/AccountMembers";
import { AccountSubHeader } from "components/account/AccountSubHeader";
import { ErrorView } from "components/common/ErrorView/ErrorView";
import { ErrorType } from "components/common/ErrorView/types";
import { UserProps } from "types/users";

export function AccountMembersPage(props: UserProps) {
  const { user } = props;
  if (!user.enable_account_invite) {
    return <ErrorView error={ErrorType.ERROR_403} />;
  }

  return (
    <Box id="account-members-page" className="h-[calc(100vh-100px)]">
      <AccountSubHeader user={user} />
      <Container sx={{ height: "calc(100% - 50px)" }}>
        <AccountMembers />
      </Container>
    </Box>
  );
}
